import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
const FeatureSection = lazy(() => import("./FeatureSection"));
const WorkflowSection = lazy(() => import("./WorkflowSection"));
const BenefitsSection = lazy(() => import("./BenefitsSection"));

const InventoryManagement = () => {
  return (
    <>
      <Helmet>
        <title>
          Inventory Management System | Cloud-Based Laboratory Information Management System | Winglo
        </title>

        <meta
          name="description"
          content="Track, manage, and optimize inventory with real-time visibility and control."
        />

        <meta
          name="keywords"
          content="Healthcare LIMS, Laboratory Information Management System, cloud LIMS software, diagnostic lab software, analyzer integration, lab automation system"
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <FeatureSection />
         <WorkflowSection />
         <BenefitsSection />
      </Suspense>
    </>
  );
};

export default InventoryManagement;
